import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17a7adb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_6 = {
  key: 0,
  class: "ant-row ant-form-vertical"
}
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_8 = { class: "ant-row ss-alinhar-centro ss-alinhar-texto-centro" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-12 ant-col-xl-3" }, " Ações em massa: ", -1))
const _hoisted_10 = { class: "ant-col ant-col-xs-12 ant-col-xl-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-12 ant-col-xl-1" }, " em ", -1))
const _hoisted_12 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-12 ant-col-xl-2" }, " no módulo ", -1))
const _hoisted_14 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-1" }, null, -1))
const _hoisted_17 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "ant-row" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_22 = { class: "ss-categoria-controle-permissoes" }
const _hoisted_23 = { class: "ant-row ss-borda-inferior" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-9" }, null, -1))
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-9" }
const _hoisted_31 = ["id"]
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_36 = { class: "ant-col ant-col-xs-24 ant-col-xl-3 ss-borda-esquerda" }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "ant-row" }
const _hoisted_39 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_40 = { class: "ss-categoria-controle-permissoes ss-display-controle-permissoes" }
const _hoisted_41 = { class: "ant-row" }
const _hoisted_42 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_card = _resolveComponent("card")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      width: "90%",
      "wrap-class-name": "full-modal",
      centered: true
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Cadastro de Perfil dos Usuários "),
        _createVNode(_component_a_switch, {
          checked: _ctx.state.perfilUsuario.ativo,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.perfilUsuario.ativo) = $event)),
          style: {"float":"right"},
          "checked-children": "Ativo",
          "un-checked-children": "Inativo"
        }, null, 8, ["checked"])
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir)
                  || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-secondary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar(true)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(false)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_a_form_item, {
                          label: "Descrição",
                          class: "ss-margin-campos",
                          rules: [{ required: true }]
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "250",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.perfilUsuario.descricao) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.perfilUsuario.descricao]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _withDirectives(_createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_a_form_item, {
                          label: "Empresas",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_empresa, {
                              varias: true,
                              empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                              codigosSelecionados: _ctx.telaBase.empresasSelecionadas,
                              "onUpdate:codigosSelecionados": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event)),
                              onChange: _ctx.atualizarSelecaoEmpresas
                            }, null, 8, ["empresasEspecificas", "codigosSelecionados", "onChange"])
                          ]),
                          _: 1
                        })
                      ], 512), [
                        [_vShow, _ctx.telaBase.apresentarEmpresas]
                      ])
                    ])
                  ]),
                  _: 1
                }),
                ((_ctx.state.permissoesCarregadas))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_card, { titulo: "PERMISSÕES" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _hoisted_9,
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_a_select, {
                                  value: _ctx.state.valorAcaoMassa,
                                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.valorAcaoMassa) = $event)),
                                  class: "ss-tamanho-completo"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_select_option, { value: 1 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Habilitar")
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_a_select_option, { value: 2 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Desabilitar")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _hoisted_11,
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_a_select, {
                                  value: _ctx.state.codigoControleAcaoMassa,
                                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.codigoControleAcaoMassa) = $event)),
                                  class: "ss-tamanho-completo"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_select_option, { value: 0 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Todos")
                                      ]),
                                      _: 1
                                    }),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.listaControlePermissoes, (controle) => {
                                      return (_openBlock(), _createBlock(_component_a_select_option, {
                                        key: 'opt.ctrl' + controle.tipoPermissao,
                                        value: controle.tipoPermissao
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(controle.descricao), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _hoisted_13,
                              _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_a_select, {
                                  value: _ctx.state.codigoModuloAcaoMassa,
                                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.codigoModuloAcaoMassa) = $event)),
                                  class: "ss-tamanho-completo"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_select_option, { value: 0 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("Todos")
                                      ]),
                                      _: 1
                                    }),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.listaModulosControlePermissoes, (modulo) => {
                                      return (_openBlock(), _createBlock(_component_a_select_option, {
                                        key: 'opt.mdl' + modulo.codigo,
                                        value: modulo.codigo
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(modulo.titulo), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["value"])
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("button", {
                                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.aplicarValorPermissoesEmMassa && _ctx.aplicarValorPermissoesEmMassa(...args))),
                                  type: "button",
                                  class: "ant-btn ant-btn-block ant-btn-primary"
                                }, " Aplicar ")
                              ]),
                              _hoisted_16,
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_a_select, {
                                  class: "ss-tamanho-completo",
                                  value: _ctx.state.codigoPermissaoPesquisa > 0?_ctx.state.codigoPermissaoPesquisa: undefined,
                                  "show-search": "",
                                  placeholder: "Digite para localizar uma permissão",
                                  "filter-option": false,
                                  allowClear: true,
                                  "not-found-content": _ctx.telaBase.fetching ? undefined : null,
                                  options: _ctx.state.listaPermissoes,
                                  onSearch: _cache[9] || (_cache[9] = ($event: any) => (_ctx.pesquisarPermissao($event))),
                                  onChange: _ctx.localizarPermissao
                                }, _createSlots({ _: 2 }, [
                                  (_ctx.telaBase.fetching)
                                    ? {
                                        name: "notFoundContent",
                                        fn: _withCtx(() => [
                                          _createVNode(_component_a_spin, { size: "small" })
                                        ]),
                                        key: "0"
                                      }
                                    : undefined
                                ]), 1032, ["value", "not-found-content", "options", "onChange"])
                              ])
                            ]),
                            _hoisted_18,
                            _createVNode(_component_a_tabs, {
                              activeKey: _ctx.state.codigoTabControle,
                              "onUpdate:activeKey": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.codigoTabControle) = $event)),
                              type: "card"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.listaControlePermissoes, (controle) => {
                                  return (_openBlock(), _createBlock(_component_a_tab_pane, {
                                    key: controle.tipoPermissao,
                                    tab: controle.descricao
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_tabs, {
                                        activeKey: _ctx.state.codigoTabModulo,
                                        "onUpdate:activeKey": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.codigoTabModulo) = $event)),
                                        type: "card"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(controle.modulos, (modulo) => {
                                            return (_openBlock(), _createBlock(_component_a_tab_pane, {
                                              key: (controle.tipoPermissao + modulo.codigo),
                                              tab: modulo.titulo
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modulo.categorias, (categoria) => {
                                                  return (_openBlock(), _createElementBlock("div", {
                                                    key: modulo.codigo + categoria.codigo
                                                  }, [
                                                    (controle.tipoPermissao === _ctx.ETipoPermissao.Dados)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                          _createElementVNode("div", _hoisted_20, [
                                                            _createElementVNode("div", _hoisted_21, [
                                                              _createElementVNode("span", _hoisted_22, _toDisplayString(categoria.descricao), 1)
                                                            ])
                                                          ]),
                                                          _createElementVNode("div", _hoisted_23, [
                                                            _hoisted_24,
                                                            _createElementVNode("div", _hoisted_25, [
                                                              _createVNode(_component_a_checkbox, {
                                                                checked: categoria.visualizar,
                                                                "onUpdate:checked": ($event: any) => ((categoria.visualizar) = $event),
                                                                onClick: ($event: any) => (_ctx.manipularPermissoesDados($event.target.checked,modulo.codigo,categoria.codigo,_ctx.EPermissaoDados.Visualizar)),
                                                                class: "ss-display-controle-permissoes"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("Visualizar")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["checked", "onUpdate:checked", "onClick"])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_26, [
                                                              _createVNode(_component_a_checkbox, {
                                                                checked: categoria.incluir,
                                                                "onUpdate:checked": ($event: any) => ((categoria.incluir) = $event),
                                                                onClick: ($event: any) => (_ctx.manipularPermissoesDados($event.target.checked,modulo.codigo,categoria.codigo,_ctx.EPermissaoDados.Incluir)),
                                                                class: "ss-display-controle-permissoes"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("Incluir")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["checked", "onUpdate:checked", "onClick"])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_27, [
                                                              _createVNode(_component_a_checkbox, {
                                                                checked: categoria.alterar,
                                                                "onUpdate:checked": ($event: any) => ((categoria.alterar) = $event),
                                                                onClick: ($event: any) => (_ctx.manipularPermissoesDados($event.target.checked,modulo.codigo,categoria.codigo,_ctx.EPermissaoDados.Alterar)),
                                                                class: "ss-display-controle-permissoes"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("Alterar")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["checked", "onUpdate:checked", "onClick"])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_28, [
                                                              _createVNode(_component_a_checkbox, {
                                                                checked: categoria.excluir,
                                                                "onUpdate:checked": ($event: any) => ((categoria.excluir) = $event),
                                                                onClick: ($event: any) => (_ctx.manipularPermissoesDados($event.target.checked,modulo.codigo,categoria.codigo,_ctx.EPermissaoDados.Excluir)),
                                                                class: "ss-display-controle-permissoes"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("Excluir")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["checked", "onUpdate:checked", "onClick"])
                                                            ]),
                                                            _createElementVNode("div", _hoisted_29, [
                                                              _createVNode(_component_a_checkbox, {
                                                                checked: categoria.imprimir,
                                                                "onUpdate:checked": ($event: any) => ((categoria.imprimir) = $event),
                                                                onClick: ($event: any) => (_ctx.manipularPermissoesDados($event.target.checked,modulo.codigo,categoria.codigo,_ctx.EPermissaoDados.Imprimir)),
                                                                class: "ss-display-controle-permissoes"
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  _createTextVNode("Imprimir")
                                                                ]),
                                                                _: 2
                                                              }, 1032, ["checked", "onUpdate:checked", "onClick"])
                                                            ])
                                                          ]),
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoria.permissoes, (permissao) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                              key: permissao.codigoPermissao,
                                                              class: "ant-row ss-borda-inferior"
                                                            }, [
                                                              _createElementVNode("div", _hoisted_30, [
                                                                _createElementVNode("span", {
                                                                  id: 'PER-'+ permissao.codigoPermissao,
                                                                  class: "ss-display-controle-permissoes"
                                                                }, _toDisplayString(permissao.descricaoPermissao), 9, _hoisted_31)
                                                              ]),
                                                              _createElementVNode("div", _hoisted_32, [
                                                                _createVNode(_component_a_checkbox, {
                                                                  onChange: ($event: any) => (_ctx.checarCategoriaPermissoesDados(modulo.codigo,categoria.codigo,_ctx.EPermissaoDados.Visualizar)),
                                                                  class: "ss-display-controle-permissoes",
                                                                  checked: permissao.visualizar,
                                                                  "onUpdate:checked": ($event: any) => ((permissao.visualizar) = $event)
                                                                }, null, 8, ["onChange", "checked", "onUpdate:checked"])
                                                              ]),
                                                              _createElementVNode("div", _hoisted_33, [
                                                                _createVNode(_component_a_checkbox, {
                                                                  onChange: ($event: any) => (_ctx.checarCategoriaPermissoesDados(modulo.codigo,categoria.codigo,_ctx.EPermissaoDados.Incluir)),
                                                                  class: "ss-display-controle-permissoes",
                                                                  checked: permissao.incluir,
                                                                  "onUpdate:checked": ($event: any) => ((permissao.incluir) = $event)
                                                                }, null, 8, ["onChange", "checked", "onUpdate:checked"])
                                                              ]),
                                                              _createElementVNode("div", _hoisted_34, [
                                                                _createVNode(_component_a_checkbox, {
                                                                  onChange: ($event: any) => (_ctx.checarCategoriaPermissoesDados(modulo.codigo,categoria.codigo,_ctx.EPermissaoDados.Alterar)),
                                                                  class: "ss-display-controle-permissoes",
                                                                  checked: permissao.alterar,
                                                                  "onUpdate:checked": ($event: any) => ((permissao.alterar) = $event)
                                                                }, null, 8, ["onChange", "checked", "onUpdate:checked"])
                                                              ]),
                                                              _createElementVNode("div", _hoisted_35, [
                                                                _createVNode(_component_a_checkbox, {
                                                                  onChange: ($event: any) => (_ctx.checarCategoriaPermissoesDados(modulo.codigo,categoria.codigo,_ctx.EPermissaoDados.Excluir)),
                                                                  class: "ss-display-controle-permissoes",
                                                                  checked: permissao.excluir,
                                                                  "onUpdate:checked": ($event: any) => ((permissao.excluir) = $event)
                                                                }, null, 8, ["onChange", "checked", "onUpdate:checked"])
                                                              ]),
                                                              _createElementVNode("div", _hoisted_36, [
                                                                _createVNode(_component_a_checkbox, {
                                                                  onChange: ($event: any) => (_ctx.checarCategoriaPermissoesDados(modulo.codigo,categoria.codigo,_ctx.EPermissaoDados.Imprimir)),
                                                                  class: "ss-display-controle-permissoes",
                                                                  checked: permissao.imprimir,
                                                                  "onUpdate:checked": ($event: any) => ((permissao.imprimir) = $event)
                                                                }, null, 8, ["onChange", "checked", "onUpdate:checked"])
                                                              ])
                                                            ]))
                                                          }), 128))
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                          _createElementVNode("div", _hoisted_38, [
                                                            _createElementVNode("div", _hoisted_39, [
                                                              _createElementVNode("span", _hoisted_40, [
                                                                _createVNode(_component_a_checkbox, {
                                                                  checked: categoria.visualizar,
                                                                  "onUpdate:checked": ($event: any) => ((categoria.visualizar) = $event),
                                                                  onClick: ($event: any) => (_ctx.manipularPermissoes($event.target.checked,modulo.codigo,categoria.codigo,controle.tipoPermissao))
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(categoria.descricao), 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["checked", "onUpdate:checked", "onClick"])
                                                              ])
                                                            ])
                                                          ]),
                                                          _createElementVNode("div", _hoisted_41, [
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categoria.permissoes, (permissao) => {
                                                              return (_openBlock(), _createElementBlock("div", {
                                                                key: permissao.codigoPermissao,
                                                                class: "ant-col ant-col-xs-24 ant-col-xl-12"
                                                              }, [
                                                                _createVNode(_component_a_checkbox, {
                                                                  onChange: ($event: any) => (_ctx.checarCategoriaPermissoes(modulo.codigo,categoria.codigo,controle.tipoPermissao)),
                                                                  class: "ss-display-controle-permissoes",
                                                                  checked: permissao.visualizar,
                                                                  "onUpdate:checked": ($event: any) => ((permissao.visualizar) = $event)
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createElementVNode("span", {
                                                                      id: 'PER-'+ permissao.codigoPermissao
                                                                    }, _toDisplayString(permissao.descricaoPermissao), 9, _hoisted_42)
                                                                  ]),
                                                                  _: 2
                                                                }, 1032, ["onChange", "checked", "onUpdate:checked"])
                                                              ]))
                                                            }), 128))
                                                          ])
                                                        ]))
                                                  ]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["tab"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["activeKey"])
                                    ]),
                                    _: 2
                                  }, 1032, ["tab"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["activeKey"])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}